/**
 * Implements a switch between networks
 */
import { useState } from 'react';
import { Network } from '@kattana-io/common';
import Text from '../../../../atoms/Text';
// import { switchCurrentTicker } from '../../../Authlogic';
import CexBalances from './CexBalances';
import DexBalances from './DexBalances';
import { WalletTokensBySym } from '../../../../wallet/walletReducer';

import '../../../common/balances-coins-list.scss';
import './styles.scss';

enum WalletBalanceMenuTab {
  CEX = 'CEX Token List',
  DEX = 'DEX Token List',
}

const balanceMenuTabs = [WalletBalanceMenuTab.DEX, WalletBalanceMenuTab.CEX];

interface IWalletBalanceMenu {
  error: boolean;
  mapping: WalletTokensBySym;
  network: Network;
  loading: boolean;
  onClose(): void;
}

const WalletBalanceMenu = ({
  error,
  network,
  mapping,
  loading,
  onClose,
}: IWalletBalanceMenu) => {
  const [tab, setTab] = useState(WalletBalanceMenuTab.DEX);
  // const ktnBalance = balances['KTN'] || 0;

  /**
   * Navigate to BSC pair when BSC network selected
   */
  // const buyKTN = () => {
  //   if (network.isBSC()) {
  //     switchCurrentTicker({
  //       chain: 'BSC',
  //       address: '0x48028De4A9b0d3D91180333d796021ec7757bA1B',
  //     });
  //   } else {
  //     switchCurrentTicker({
  //       chain: 'ETH',
  //       address: '0x92dBB765f587F6E16C07C799E0dB6A1f3AF498B8',
  //     });
  //   }
  // };

  return (
    <div className='balance_menu select_wallet__appear_box'>
      <div className='balance_menu__tabs'>
        {balanceMenuTabs.map((item) => (
          <div
            key={item}
            className={`watchlist__tabs__tab ${
              item === tab ? 'watchlist__tabs__tab--active' : ''
            }`}
            onClick={() => setTab(item)}
          >
            <Text size={12}>{item}</Text>
          </div>
        ))}
      </div>
      {tab === WalletBalanceMenuTab.CEX && <CexBalances />}
      {tab === WalletBalanceMenuTab.DEX && (
        <>
          {loading && <div className='loader' />}
          {!loading && !error && (
            <DexBalances
              mapping={mapping}
              chain={network.getSymbol()}
              onClose={onClose}
            />
          )}
          {error && (
            <Text size={12} className='warning'>
              Could not fetch balance of your wallet
            </Text>
          )}
        </>
      )}
    </div>
  );
};

export default WalletBalanceMenu;
